import React from 'react';

import useReviewFormParams from 'screens/performanceReview/hooks/useReviewFormParams';

import { Paper } from 'uiToolkitV1/Paper';

import { useReviewFormSidebarDataOld } from '../Sidebar/hooks/dataHooks';
import SubmitFormFooter from '../SubmitFormFooter/SubmitFormFooter';
import { ReviewFormFillingScore } from './components/PerformanceScore';

const CongratsFooter = () => {
  // unable to figure out why reading from cache isn't working,
  // so using API call to get latest data
  const { employeeId, providerId, reviewId } = useReviewFormParams();
  const { data: formData } = useReviewFormSidebarDataOld({ employeeId, providerId, reviewId });
  const { isAllRequiredQuestionsAnswered } = formData ?? {};

  const { isShowGoalRating, isShowCompetencyRating, isShowQNARating } = formData;

  const showRatingFooter = isShowCompetencyRating || isShowGoalRating || isShowQNARating;

  return (
    <Paper mt="16px" p="16px" boxShadow="0px 0px 2px rgba(0, 0, 0, 0.25)">
      {isAllRequiredQuestionsAnswered && showRatingFooter && <ReviewFormFillingScore />}
      <SubmitFormFooter />
    </Paper>
  );
};

export default CongratsFooter;
